import { render, staticRenderFns } from "./cloudSchoolIndex.vue?vue&type=template&id=08a5f115&scoped=true"
import script from "./cloudSchoolIndex.vue?vue&type=script&lang=js"
export * from "./cloudSchoolIndex.vue?vue&type=script&lang=js"
import style0 from "./cloudSchoolIndex.vue?vue&type=style&index=0&id=08a5f115&prod&lang=scss&scoped=true"
import style1 from "./cloudSchoolIndex.vue?vue&type=style&index=1&id=08a5f115&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5f115",
  null
  
)

export default component.exports